import * as Styles from "./LandingInfo.styles";
import Grid from "@mui/material/Grid2";
import landingPageImage from "../../assets/images/landingPageImage.svg";
import LandingInfoItem from "./components/LandingInfoItem";

const NOTA_FISCAL_INFORMATION_ITEMS = [
  "cProd: Código do produto",
  "cEAN: Código de barras",
  "xProd: Nome produto",
  "uCom: Unidade medida",
  "qCom: Quantidade",
];

export default function LandingInfo() {
  return (
    <Styles.LandingImageContainer>
      <Styles.LandingContent>
        <img src={landingPageImage} alt="landing" />

        <Styles.LandingInfoContainer>
          <Styles.LandingInfoHeader>
            <h4>Inicie importando um arquivo ou realizando a leitura de códigos de barras.</h4>

            <h5>Requisitos do XML. O arquivo XML deve conter obrigatoriamente as seguintes tags:</h5>

            <Grid container spacing={1}>
              {NOTA_FISCAL_INFORMATION_ITEMS.map((item, index) => (
                <Grid size={6} key={index}>
                  <LandingInfoItem text={item} />
                </Grid>
              ))}
            </Grid>
          </Styles.LandingInfoHeader>
        </Styles.LandingInfoContainer>
      </Styles.LandingContent>
    </Styles.LandingImageContainer>
  );
}
